/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApplicationDocumentTypeEnum } from '../models/ApplicationDocumentTypeEnum';
import type { CreatingApplicationCommand } from '../models/CreatingApplicationCommand';
import type { EpochEnum } from '../models/EpochEnum';
import type { ProcessTypeEnum } from '../models/ProcessTypeEnum';
import type { ResponseData_ApplicationAgentContractResponse } from '../models/ResponseData_ApplicationAgentContractResponse';
import type { ResponseData_ApplicationContractResponse } from '../models/ResponseData_ApplicationContractResponse';
import type { ResponseData_ApplicationFeeResponse } from '../models/ResponseData_ApplicationFeeResponse';
import type { ResponseData_ApplicationParticipantsResponse } from '../models/ResponseData_ApplicationParticipantsResponse';
import type { ResponseData_ApplicationResponse } from '../models/ResponseData_ApplicationResponse';
import type { ResponseData_Array_ApplicationCommentResponse } from '../models/ResponseData_Array_ApplicationCommentResponse';
import type { ResponseData_Array_ApplicationDocumentResponse } from '../models/ResponseData_Array_ApplicationDocumentResponse';
import type { ResponseData_Array_ApplicationExchangeRateResponse } from '../models/ResponseData_Array_ApplicationExchangeRateResponse';
import type { ResponseData_Array_ApplicationHistoryResponse } from '../models/ResponseData_Array_ApplicationHistoryResponse';
import type { ResponseData_Guid } from '../models/ResponseData_Guid';
import type { ResponseData_List_ApplicationEpochListResponse } from '../models/ResponseData_List_ApplicationEpochListResponse';
import type { ResponseData_PagedResponse_AllApplicationsDocumentResponse } from '../models/ResponseData_PagedResponse_AllApplicationsDocumentResponse';
import type { ResponseData_PagedResponse_ApplicationListResponse } from '../models/ResponseData_PagedResponse_ApplicationListResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ApplicationService {
  /**
   * Создать зявку
   * @returns ResponseData_Guid OK
   * @throws ApiError
   */
  public static postApiV1ApplicationCreate({
    requestBody,
  }: {
    requestBody?: CreatingApplicationCommand;
  }): CancelablePromise<ResponseData_Guid> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/application/create',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Получить заявку по идентификатору
   * @returns ResponseData_ApplicationResponse OK
   * @throws ApiError
   */
  public static getApiV1Application({
    id,
  }: {
    id: string;
  }): CancelablePromise<ResponseData_ApplicationResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/application/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * Получить информацию о клиенте заявки
   * @returns ResponseData_ApplicationParticipantsResponse OK
   * @throws ApiError
   */
  public static getApiV1ApplicationParticipants({
    id,
  }: {
    id: string;
  }): CancelablePromise<ResponseData_ApplicationParticipantsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/application/{id}/participants',
      path: {
        id: id,
      },
    });
  }
  /**
   * Получить информацию о контракте заявки
   * @returns ResponseData_ApplicationContractResponse OK
   * @throws ApiError
   */
  public static getApiV1ApplicationContract({
    id,
  }: {
    id: string;
  }): CancelablePromise<ResponseData_ApplicationContractResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/application/{id}/contract',
      path: {
        id: id,
      },
    });
  }
  /**
   * Получить информацию о контракте с агентом
   * @returns ResponseData_ApplicationAgentContractResponse OK
   * @throws ApiError
   */
  public static getApiV1ApplicationAgentContract({
    id,
  }: {
    id: string;
  }): CancelablePromise<ResponseData_ApplicationAgentContractResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/application/{id}/agentContract',
      path: {
        id: id,
      },
    });
  }
  /**
   * Получить историю заявки по идентификатору
   * @returns ResponseData_Array_ApplicationHistoryResponse OK
   * @throws ApiError
   */
  public static getApiV1ApplicationHistory({
    id,
  }: {
    id: string;
  }): CancelablePromise<ResponseData_Array_ApplicationHistoryResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/application/{id}/history',
      path: {
        id: id,
      },
    });
  }
  /**
   * Получить комментарии заявки по идентификатору
   * @returns ResponseData_Array_ApplicationCommentResponse OK
   * @throws ApiError
   */
  public static getApiV1ApplicationComments({
    id,
  }: {
    id: string;
  }): CancelablePromise<ResponseData_Array_ApplicationCommentResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/application/{id}/comments',
      path: {
        id: id,
      },
    });
  }
  /**
   * Получить комиссии заявки по идентификатору
   * @returns ResponseData_ApplicationFeeResponse OK
   * @throws ApiError
   */
  public static getApiV1ApplicationFee({
    id,
  }: {
    id: string;
  }): CancelablePromise<ResponseData_ApplicationFeeResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/application/{id}/fee',
      path: {
        id: id,
      },
    });
  }
  /**
   * Получить список заявок
   * @returns ResponseData_PagedResponse_ApplicationListResponse OK
   * @throws ApiError
   */
  public static getApiV1ApplicationList({
    epochId,
    currencyId,
    processTypeId,
    dateFrom,
    dateTo,
    pageNumber,
    pageSize,
  }: {
    epochId?: EpochEnum;
    currencyId?: number;
    processTypeId?: ProcessTypeEnum;
    dateFrom?: string;
    dateTo?: string;
    pageNumber?: number;
    pageSize?: number;
  }): CancelablePromise<ResponseData_PagedResponse_ApplicationListResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/application/list',
      query: {
        epochId: epochId,
        currencyId: currencyId,
        processTypeId: processTypeId,
        dateFrom: dateFrom,
        dateTo: dateTo,
        pageNumber: pageNumber,
        pageSize: pageSize,
      },
    });
  }
  /**
   * Получить документы всех заявок
   * @returns ResponseData_PagedResponse_AllApplicationsDocumentResponse OK
   * @throws ApiError
   */
  public static getApiV1ApplicationDocument({
    documentTypeIds,
    dateFrom,
    dateTo,
    search,
    pageNumber,
    pageSize,
  }: {
    documentTypeIds?: Array<ApplicationDocumentTypeEnum>;
    dateFrom?: string;
    dateTo?: string;
    search?: string;
    pageNumber?: number;
    pageSize?: number;
  }): CancelablePromise<ResponseData_PagedResponse_AllApplicationsDocumentResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/application/document',
      query: {
        documentTypeIds: documentTypeIds,
        dateFrom: dateFrom,
        dateTo: dateTo,
        search: search,
        pageNumber: pageNumber,
        pageSize: pageSize,
      },
    });
  }
  /**
   * Получить документы заявки
   * @returns ResponseData_Array_ApplicationDocumentResponse OK
   * @throws ApiError
   */
  public static getApiV1ApplicationDocument1({
    id,
  }: {
    id: string;
  }): CancelablePromise<ResponseData_Array_ApplicationDocumentResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/application/{id}/document',
      path: {
        id: id,
      },
    });
  }
  /**
   * Получить документ заявки по идентификатору
   * @returns binary OK
   * @throws ApiError
   */
  public static getApiV1ApplicationDocument2({
    id,
  }: {
    id: string;
  }): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/application/document/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * Получить подпись по идентификатору
   * @returns binary OK
   * @throws ApiError
   */
  public static getApiV1ApplicationDocumentSign({
    id,
  }: {
    id: string;
  }): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/application/document/sign/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * Получить список эпох
   * @returns ResponseData_List_ApplicationEpochListResponse OK
   * @throws ApiError
   */
  public static getApiV1ApplicationEpochs(): CancelablePromise<ResponseData_List_ApplicationEpochListResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/application/epochs',
    });
  }
  /**
   * Получить список поставщиков ликвидности
   * @returns ResponseData_Array_ApplicationExchangeRateResponse OK
   * @throws ApiError
   */
  public static getApiV1ApplicationExchangeOffers({
    id,
  }: {
    id: string;
  }): CancelablePromise<ResponseData_Array_ApplicationExchangeRateResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/application/{id}/exchangeOffers',
      path: {
        id: id,
      },
    });
  }
}
